export const getDepartmentDivisions = (org, options) =>
  (org && options && options[0] && options[0][org]) || [];

export const isDepartmentVisible = (org, options) =>
  getDepartmentDivisions(org, options).length > 0;
